// Il backend serializza gli enum come stringa (JsonStringEnumConverter),
// quindi "value" deve corrispondere al nome del membro C# di StatoIncasso.
export const STATI_INCASSO = [
    { label: "Da incassare", value: "DaIncassare" },
    { label: "Incassato", value: "Incassato" },
    { label: "Annullato", value: "Annullato" },
];

const COLORI_STATO = {
    DaIncassare: "success",
    Incassato: "info",
    Annullato: "grey",
};

export function coloreStatoIncasso(stato) {
    return COLORI_STATO[stato] || "grey";
}

export function etichettaStatoIncasso(stato) {
    return (STATI_INCASSO.find(s => s.value === stato) || {}).label || "";
}

// "Scaduto" calcolato client-side (Incasso non ha, come Pagamento, un
// campo calcolato server-side garantito dal contratto): DaIncassare con
// DataScadenza nel passato.
export function isScaduto(item) {
    if (!item || item.stato !== "DaIncassare" || !item.dataScadenza) return false;
    const oggi = new Date();
    oggi.setHours(0, 0, 0, 0);
    const scadenza = new Date(item.dataScadenza);
    scadenza.setHours(0, 0, 0, 0);
    return scadenza.getTime() < oggi.getTime();
}

export function coloreRiga(item) {
    if (isScaduto(item)) return "error";
    return coloreStatoIncasso(item.stato);
}

export function etichettaRiga(item) {
    if (isScaduto(item)) return "Scaduto";
    return etichettaStatoIncasso(item.stato);
}
